import React from "react";
import theme from "../../../styles/theme"; 

const PageHeader = ({ title, subtitle, logo, className, titleColor }) => {
  return (
    <div
      style={{
        marginBottom: theme.spacing.xs,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.xs,
        marginLeft: 12,
      }}
    >
      {/* 🔹 Ligne logo + label (optionnelle) */}
      {logo && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {logo.src && (
            <img
              src={logo.src}
              alt="logo"
              style={{ height: 32, width: 32 }}
            />
          )}
          {logo.label && (
            <span
              style={{
                fontFamily: theme.fonts.corelia,
                fontWeight: theme.fontWeights.corelia,
                fontSize: theme.fontSizes.xl,
                color: theme.colors.text.corelia,
                letterSpacing: "1px",
              }}
            >
              {logo.label}
            </span>
          )}
        </div>
      )}

      {/* 🔹 Titre */}
      <h1
        className={className}
        style={{
          fontSize: theme.fontSizes.xl,
          margin: 0,
          fontStyle: theme.fonts.secondary,
          color: titleColor || theme.colors.text.default,
        }}
      >
        {title}
      </h1>

      {/* 🔹 Sous-titre */}
      {subtitle && (
        <p
          style={{
            fontSize: theme.fontSizes.md,
            color: theme.colors.text.small,
            margin: 0,
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default PageHeader;